import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Work Orders
export const getWorkOrders = async (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  const response = await axios.get(`${API}/work-orders${params ? `?${params}` : ''}`);
  return response.data;
};

export const getWorkOrder = async (id) => {
  const response = await axios.get(`${API}/work-orders/${id}`);
  return response.data;
};

export const createWorkOrder = async (data) => {
  const response = await axios.post(`${API}/work-orders`, data);
  return response.data;
};

export const updateWorkOrder = async (id, data) => {
  const response = await axios.patch(`${API}/work-orders/${id}`, data);
  return response.data;
};

export const deleteWorkOrder = async (id) => {
  const response = await axios.delete(`${API}/work-orders/${id}`);
  return response.data;
};

// Comments
export const getComments = async (workOrderId) => {
  const response = await axios.get(`${API}/work-orders/${workOrderId}/comments`);
  return response.data;
};

export const createComment = async (workOrderId, content) => {
  const response = await axios.post(`${API}/work-orders/${workOrderId}/comments`, { content });
  return response.data;
};

// Approvals
export const approveWorkOrder = async (workOrderId, approved, rejection_reason = null) => {
  const response = await axios.post(`${API}/work-orders/${workOrderId}/approve`, {
    approved,
    rejection_reason,
  });
  return response.data;
};

// Notifications
export const getNotifications = async () => {
  const response = await axios.get(`${API}/notifications`);
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await axios.patch(`${API}/notifications/${id}/read`);
  return response.data;
};

// Users
export const getUsers = async () => {
  const response = await axios.get(`${API}/users`);
  return response.data;
};

// Staff
export const getStaff = async () => {
  const response = await axios.get(`${API}/staff`);
  return response.data;
};

export const getAllStaff = async () => {
  const response = await axios.get(`${API}/staff/all`);
  return response.data;
};

export const createStaff = async (data) => {
  const response = await axios.post(`${API}/staff`, data);
  return response.data;
};

export const updateStaff = async (id, data) => {
  const response = await axios.patch(`${API}/staff/${id}`, data);
  return response.data;
};

export const deleteStaff = async (id) => {
  const response = await axios.delete(`${API}/staff/${id}`);
  return response.data;
};

// Task confirmation (simpler approval for Tasks)
export const confirmTask = async (workOrderId) => {
  const response = await axios.post(`${API}/work-orders/${workOrderId}/confirm-task`);
  return response.data;
};

export const getPendingTasks = async () => {
  const response = await axios.get(`${API}/work-orders/pending-tasks`);
  return response.data;
};

// Staff Performance Dashboard
export const getStaffPerformance = async () => {
  const response = await axios.get(`${API}/staff/performance`);
  return response.data;
};

// Attachments
export const uploadAttachment = async (workOrderId, file, description = '') => {
  const formData = new FormData();
  formData.append('file', file);
  if (description) {
    formData.append('description', description);
  }
  const response = await axios.post(`${API}/work-orders/${workOrderId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getAttachments = async (workOrderId) => {
  const response = await axios.get(`${API}/work-orders/${workOrderId}/attachments`);
  return response.data;
};

export const deleteAttachment = async (workOrderId, attachmentId) => {
  const response = await axios.delete(`${API}/work-orders/${workOrderId}/attachments/${attachmentId}`);
  return response.data;
};

// Dashboard
export const getDashboardStats = async () => {
  const response = await axios.get(`${API}/dashboard/stats`);
  return response.data;
};

// Invoices
export const getInvoices = async () => {
  const response = await axios.get(`${API}/invoices`);
  return response.data;
};

export const markInvoicePaid = async (id) => {
  const response = await axios.patch(`${API}/invoices/${id}/pay`);
  return response.data;
};

// File uploads
export const uploadPhoto = async (workOrderId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API}/work-orders/${workOrderId}/upload-photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadDocument = async (workOrderId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API}/work-orders/${workOrderId}/upload-document`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
